























import { Component, Vue } from "vue-property-decorator";
import DisclaimerAccordion from "@/components/designer/reusable/DisclaimerAccordion.vue";
import { bullionFringeExcludedModels } from "@/mixins/business_logic/global/attribute_rules";

@Component({
  components: { DisclaimerAccordion }
})
export default class FringeFabricDisclaimer extends Vue {
  /**
   * Every model that cannot carry the 3"/5" bullion fringes, listed in full
   * and shown at all times rather than keyed off the current selection.
   * Read from the shared exclusion list so the copy can't drift from the
   * rule that actually gates the options.
   */
  get restrictedModels(): string {
    const models = bullionFringeExcludedModels;
    if (models.length < 2) return models.join("");
    return (
      models.slice(0, -1).join(", ") + " and " + models[models.length - 1]
    );
  }
}
